import React from 'react';
import clientImg from '../img/client.jpg'
import JointCommission from './JointCommission';

function Clients() {
  return (
    <>
    <div className="breadcrumb-area gradient-bg bg-cover shadow dark text-light text-center" style={{backgroundImage: `url(${clientImg})`}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <h1>Clients Information</h1>
                    <ul className="breadcrumb">
                        <li><a href="/"><i className="fas fa-home"></i> Home</a></li>
                        <li className="active">Clients</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="blog-area single full-blog right-sidebar default-padding">
        <div className="container">
            <div className="blog-items">
                <div className="row">
                    <div className="blog-content col-lg-8 col-md-12">
                        
                        <div className="single-item">

                            <div className="blog-item-box">
                                <div className="item">
                                    <div className="info">

                                        <p>
                                            Divine CHP Staffing is a Joint Commission certified staffing dedicated to providing efficient, reliable, and compassionate healthcare services to all our clients. At Divine CHP Staffing, we believe in the importance of maintaining high quality and excellent care. Our recruitment process is very detailed; therefore, we have built a team of best healthcare professionals who fully comply with the highest standards of practice and the latest evidence-based practice with respect to patient privacy and dignity.
                                        </p>
                                        
                                        <p>
                                            At Divine CHP staffing , we believe in the importance of excellent and consistent service while providing continuity of care. That is why we have built a dedicated team of the best healthcare professionals for every service offered. We have detailed, multi-step processes for recruiting health care professionals and these protocols fully comply with the high standards of practice across clinical governance, disclosure and barring service checks, health and safety, occupational health, and training, and healthcare standards.
                                        </p>
                                        
                                        <blockquote>
                                            Choose Divine CHP Staffing for all your staffing needs, and we will send you the most qualified healthcare professionals to meet your needs.
                                        </blockquote>
                                        
                                        <h5><i><b>Our recruitment procedure include but is not limited to the following stages;</b></i></h5>

                                        <ul>
                        										<li>Online Application / Recruiter</li>
                        										<li>Competency test</li>
                        										<li>Interviews</li>
                        										<li>License verification</li>
                        										<li>Immunization up to date</li>
                        										<li>Lifetime criminal Background check (Nationwide)</li>
                        										<li>E-verify (Employment eligibility)</li>
                        										<li>Full Identification</li>
                        										<li>3 Reference checks</li>
                        										<li>Orientation</li>
                        										<li>Drug Screening</li>
                                        </ul>
                                       <p> If you need more informations on any of our processes, please feel free to <a href="contact">contact us</a> and we will be very happy to get back to you in our earliest. </p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sidebar col-lg-4 col-md-12">
                        <aside>
                            <JointCommission />
                        </aside>
                    </div>

                </div>
            </div>
        </div>
    </div>
    </>
  );
}

export default Clients;